import { forwardRef, useEffect, useRef } from "react";
import Quill from "quill";
import "quill/dist/quill.snow.css";

const QuillEditor = forwardRef((ref) => {
  // const myColors = [
  //   "purple",
  //   "#785412",
  //   "#452632",
  //   "#856325",
  //   "#963254",
  //   "#254563",
  //   "white",
  // ];
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      // [{ align: ["right", "center", "justify"] }],
      [{ list: "ordered" }, { list: "bullet" }],
      // ["link", "image"],
      // [{ color: myColors }],
      // [{ background: myColors }],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    // "color",
    // "image",
    // "background",
    // "align",
  ];
  const options = {
    modules: modules,
    formats: formats,
    theme: "snow",
    placeholder: "Compose an epic...",
  };

  const isMounted = useRef(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;

    if (container && !isMounted.current) {
      const quill = new Quill(container!, options);
      isMounted.current = true;
      const value = `<div><p><b>Welcome to CorrectEnglish!</b></p>
    <p>
      If correct spelling earns you a few extra points on your papers,
      proper grammar will make a whole world of difference. Writing
      eloquently is a sign that you have a good understanding of the
      English language, which make a positive impression on readers.
    </p>
  
    <p>
      <b>Super simple - Just start writing!</b>
    </p>
    <p>
      Just start typing! Yes, it's that eazy! CorrectEnglish instantly
      checks you grammar as you write. But even better, it offers
      explanations so that you can learn as you go!
    </p>
  
    <p>
      <b>Easy mistakes, easily fixed!</b>
    </p>
    <p>
      Each error will be highlighted by a colorful underline, which will
      tell you the type of error it found: green for style suggestions,
      red for spelling errors, and grammar errors will be displayed in
      blue. The dot in the bottom-right corner also tells you how many
      errors there are.
    </p>
  
    <p>
      <b>Green, red, blue!</b>
    </p>
    <p>
      Go ahead and click on the gren, red or blue underlined words. Notice
      the cards that pop up to display the error description, and
      suggested improvement! Practicing good grammar have never been
      easier. For example, you will be able to create metaphors and use
      other stylistic techniques that are easily understandable with
      proper grammar.
    </p>
  
    <p>
      <b>But Wait! There's more?</b>
    </p>
    <p>
      CorrectEnglish is more then just a grammar and spelling checker!
      Take a quick tour around. Locate the "Language" dropdown:
      CorrectEnglish provides targeted instruction in NiNE languages.
    </p>
  
    <p>
      <b>What about the gray lines?</b>
    </p>
    <p>
      This Free Forever edition provides grammar insight up to to 250
      words per text. Upgrade to experience the full power of the
      CorrectEnglish writing mastery program. The CorrectEnglish premium
      edition provide a 24/7, dedicated writing environment with all the
      tools you need to improve your writing.
    </p>
    <p>Happy Writin!</p></div>`;
      const delta = quill.clipboard.convert({ html: value });
      quill.setContents(delta, "silent");
    }
  }, [ref]);

  return <div id="editor" ref={containerRef} style={{ height: "70vh" }}></div>;
});

export default QuillEditor;
